export const TutorialNotificationButtons = {
  childExtends: ['CanvasButton', 'Button'],
  align: 'center center',
  flow: 'x',
  fontSize: 'Z2',
  // Top divider removed (border-habit sweep, design-direction.md §8) — the
  // parent card (TutorialNotification / TutorialGifNotificationSlider, both
  // `theme: 'canvas-card-glass'`) already supplies the surface fill this bar
  // sits on, same precedent as AiActionConfirmCard's Header/Footer.
  height: '100%',
  // Root gap replaces the inter-button divider (was a `:not(:last-child)`
  // `line-highlight` border — §2.5 house rule: "row separators inside
  // rounded cards stay banned — gap + hover tint instead").
  gap: 'X2',
  childProps: {
    round: '0',
    padding: 'A',
    flex: 1,
    gap: 'X2'
  },
  children: [
    {
      icon: 'sf question oval',
      text: '{{ common.action.learn_more | polyglot }}',
      onClick: (ev, el, s) => {
        el.setWindow('docs', s.docsArticle)
      }
    },
    {
      icon: 'checkmark',
      text: '{{ common.action.okay | polyglot }}',
      onClick: (ev, el, s) => {
        if (s.callback) el.call('exec', s.callback)
        el.lookup((el) => el.rootSlide).remove()
        const markKey = 'tutorialMarked_' + s.key
        el.call('setCookie', markKey, true)
      }
    }
  ]
}
